import { DialogResult } from '@/shared/dialog/dialog-result'
import { Injector } from '@/config/dependency-injection'
import { DialogService } from '@/shared/dialog/dialog-service'
import { ResetPasswordDialogInput } from '@/business/administration/components/reset-password/reset-password-dialog-input'
import ResetPasswordDialog from '@/business/administration/components/reset-password/reset-password-dialog.vue'

export function resetPasswordDialog(
  properties: ResetPasswordDialogInput
): DialogResult<void, void> {
  const dialogService = Injector.get(DialogService)

  return dialogService.openDynamic(ResetPasswordDialog, properties)
}
